import axios from "axios";
import { CONTACT_URL } from "../../../../../src/_metronic/_helpers/Constants";


export function sendMessage(fullname, email, phone, message) {
  return axios.post(CONTACT_URL, { fullname, email, phone, text: message })
}